const timesDataFactory = (type, baseTimes) => {
    const typeConfigurations = {
        uptime_monitoring: (data) => data.map((item) => {
            if (item.key === baseTimes?.one_hour?.key) return {...item, interval: 'minute', limit: 60}
            if (item.key === baseTimes?.three_hours?.key) return {...item, interval: 'minute', limit: 180}
            if (item.key === baseTimes?.twelve_hours?.key) return {...item, interval: 'hour', limit: 12}
            if (item.key === baseTimes?.one_day?.key) return {...item, interval: 'hour', limit: 24}
            if (item.key === baseTimes?.three_days?.key) return {...item, interval: 'hour', limit: 72}
            if (item.key === baseTimes?.seven_days?.key) return {...item, interval: 'day', limit: 7}
            if (item.key === baseTimes?.one_month?.key) return {...item, interval: 'day', limit: 30}
            return item
        }),
        server_monitoring: (data) => data.map((item) => {
            if (item.key === baseTimes?.one_hour?.key || item.key === baseTimes?.three_hours?.key) return {...item, interval: 'on-demand'}
            if ([baseTimes?.twelve_hours?.key, baseTimes?.one_day?.key, baseTimes?.three_days?.key].includes(item.key)) return {...item, interval: 'hour'}
            if (item.key === baseTimes?.seven_days?.key) return {...item, interval: 'hour', value: 168}
            if (item.key === baseTimes?.one_month?.key) return {...item, interval: 'day'}
            return item
        }),
        heartbeat_monitoring: (data) => data.map((item) => {
            if (item.key === baseTimes?.seven_days?.key || item.key === baseTimes?.one_month?.key) return {...item, interval: item.key, value: 24 * item.value}
            return {...item, interval: item.key}
        })
    }

    const applyConfiguration = typeConfigurations[type] || typeConfigurations.uptime_monitoring

    return applyConfiguration([...Object.values(baseTimes)])
}

export {
    timesDataFactory
}
